import React, { useState } from 'react';
import {
  Container,
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import RoomManagement from './admin/RoomManagement';
import UserManagement from './admin/UserManagement';
import EquipmentManagement from './admin/EquipmentManagement';

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index} role="tabpanel">
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

function AdminPage() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 3, mt: 2 }}>
        <Typography variant="h4" gutterBottom>
          Administration
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage rooms, users, and system configuration
        </Typography>
      </Box>

      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Room Management" />
          <Tab label="User Management" />
          <Tab label="Equipment" />
        </Tabs>

        <TabPanel value={activeTab} index={0}>
          <RoomManagement />
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <UserManagement />
        </TabPanel>

        <TabPanel value={activeTab} index={2}>
          <EquipmentManagement />
        </TabPanel>
      </Paper>
    </Container>
  );
}

export default AdminPage;
